import classNames from 'classnames'

interface IGetRequestIcon {
  status: string
  modified: string
  styles: {
    readonly [key: string]: string
  }
}

export const getRequestIcon = ({ modified, status, styles }: IGetRequestIcon) => {
  switch (status) {
    case 'WIP':
      return (
        <i
          className={classNames(
            styles.requests__icon,
            styles['requests--wip'],
            'kbase kbase-lvl-clock'
          )}
        />
      )
    case 'Rejected':
      return (
        <i
          className={classNames(
            styles.requests__icon,
            styles['requests--rejected'],
            'kbase kbase-info-alt'
          )}
        />
      )
    case 'Done':
      return (
        modified &&
        Date.parse(modified) > +new Date() - 86400000 && (
          <i
            className={classNames(
              styles.requests__icon,
              styles['requests--done'],
              'kbase kbase-check-circle'
            )}
          />
        )
      )
    case 'New':
      return (
        <i
          className={classNames(styles.requests__icon, styles['requests--new'], 'kbase kbase-add')}
        />
      )
  }
  return
}
